module.exports = __webpack_public_path__ + "img/contacts-map.ce14324.webp";